import { useDesignSystem } from 'contexts/design-system'
import ReasonPickerEui from './reasonPicker.eui'
import ReasonPickerMui from './reasonPicker.mui'
import { ReasonPickerProps } from './types'

export type { ReasonPickerProps } from './types'
export { getReasonVariables } from './useReasonOptions'

/**
 * Shared manual-adjustment reason picker. Renders the EUI or MUI presentation
 * based on the host form's design system (`DesignSystemProvider`, default
 * `'eui'`). The reason query and option filtering are shared by both branches
 * (`useReasonOptions`), so only the presentation differs.
 */
export default function ReasonPicker( props: ReasonPickerProps ) {
	return useDesignSystem() === 'mui'
		? <ReasonPickerMui {...props} />
		: <ReasonPickerEui {...props} />
}
